import Model from '@/models/Model'

export default class WhDetailInventory extends Model {

    //
    //amount_found_new = 0

    /**
     * 
     */
    get amount_found_edited () {
        console.log(this.flag_replace)
        return this.flag_replace ? Number( this.amount_found_new || 0 ) : Number( this.amount_found || 0 ) + Number( this.amount_found_new || 0 )
    }

    /**
     * 
     */
    resource() {
        return 'wh_detail_inventory'
    }
}